import { DropdownOption } from "@shared/models/dropdown.model";
import { languageOptions } from "./language.const";

export const insightSegmentAll = "all";

const planSegmentOptions: DropdownOption<string>[] = [
  { value: "plan:free", label: "Gói: Miễn phí" },
  { value: "plan:monthly", label: "Gói: Hàng tháng" },
  { value: "plan:annually", label: "Gói: Hàng năm" },
];

const platformSegmentOptions: DropdownOption<string>[] = [
  { value: "platform:android", label: "Nền tảng: Android" },
  { value: "platform:iphone", label: "Nền tảng: iPhone" },
  { value: "platform:ipad", label: "Nền tảng: iPad" },
];

const languageSegmentOptions: DropdownOption<string>[] = languageOptions.map(
  (language) => ({
    value: `lang:${language.value}`,
    label: `Ngôn ngữ: ${language.label}`,
  })
);

const familySizeSegmentOptions: DropdownOption<string>[] = [
  { value: "size:1", label: "Quy mô: 1 thành viên" },
  { value: "size:2", label: "Quy mô: 2 thành viên" },
  { value: "size:3", label: "Quy mô: 3 thành viên" },
  { value: "size:4", label: "Quy mô: 4 thành viên" },
  { value: "size:5plus", label: "Quy mô: 5 thành viên trở lên" },
];

export const insightSegmentOptions: DropdownOption<string>[] = [
  { value: insightSegmentAll, label: "Tất cả" },
  ...planSegmentOptions,
  ...platformSegmentOptions,
  ...languageSegmentOptions,
  ...familySizeSegmentOptions,
];
